import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'
import toHashStringUtil from 'utils/string/to-hash/index.js'
import toDomAnchorIdStringUtil from 'utils/string/to-dom-anchor-id/index.js'
import Hoverable from 'components/Hoverable/index.js'
import Link from 'components/Link/index.js'
import { appendHashLocationUtil } from 'modules/router/utils/append-hash/index.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getLocationRouterSelect from 'modules/router/selectors/get-location/index.js'
import TextBody from 'components/TextBody/index.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import { isSmallMobileScreenViewportSelect } from 'modules/viewport/selectors/index.js'

const ANALYTICS_KEY = {
  VIEW_FEATURE_LINE: 'VIEW_FEATURE_LINE'
}

/**
 * @param props
 * @param props.areFeaturesPressable
 * @param props.message
 * @param props.isMuchMore
 * @param props.onPressMuchMore
 * @param props.isBold
 * @returns {Element}
 * @constructor
 */
export default function SubscriptionPlanFeatureLine (props) {
  const {
    areFeaturesPressable,
    message,
    isMuchMore,
    onPressMuchMore,
    isBold
  } = props

  const intl = useIntl()
  const label = formatMessageIntlUtil(intl, message)
  const location = useSelector(getLocationRouterSelect)
  const isSmallMobileScreen = useSelector(isSmallMobileScreenViewportSelect)

  const textStyle = {
    textAlign: 'left'
  }

  if (isMuchMore) {
    textStyle.textDecoration = 'underline'
  }

  const children = (
    <TextBody
      style={textStyle}
      fs={isSmallMobileScreen ? '0.8rem' : '1rem'}
      fw={isBold ? 'bold' : '400'}
    >
      {label}
    </TextBody>
  )

  if (
    !areFeaturesPressable &&
    isMuchMore
  ) {
    return (
      <Hoverable>
        <div
          onClick={onPressMuchMore}
          style={{
            cursor: 'pointer',
            textAlign: 'left'
          }}
        >
          {children}
        </div>
      </Hoverable>
    )
  }

  if (!areFeaturesPressable) {
    return children
  }

  const hash = toHashStringUtil(
    toDomAnchorIdStringUtil(label)
  )

  const handleClick = () => {
    logEventAnalyticsUtil(ANALYTICS_KEY.VIEW_FEATURE_LINE + label)
  }

  return (
    <Hoverable>
      <Link
        to={appendHashLocationUtil(location, hash)}
        onClick={handleClick}
        style={{
          textAlign: 'left'
        }}
      >
        {children}
      </Link>
    </Hoverable>
  )
}
